// Simon & Layan Wishlist — localStorage 收藏功能
(function () {
  const KEY = 'sl_wishlist';
  function getList() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function setList(list) { localStorage.setItem(KEY, JSON.stringify(list)); }

  window.SL_Wishlist = {
    getList: getList,
    has: function (handle) { return getList().indexOf(handle) !== -1; },
    toggle: function (handle) {
      const list = getList();
      const idx = list.indexOf(handle);
      if (idx === -1) { list.push(handle); } else { list.splice(idx, 1); }
      setList(list);
      document.querySelectorAll('[data-wishlist="' + handle + '"]').forEach(function (btn) {
        btn.classList.toggle('active', idx === -1);
        btn.setAttribute('aria-pressed', idx === -1 ? 'true' : 'false');
        btn.textContent = idx === -1 ? '♥' : '♡';
      });
      const counter = document.getElementById('wishlist-count');
      if (counter && !counter.classList.contains('wishlist-page-count')) counter.textContent = list.length;
      // ★新增：header 收藏角标实时同步
      const headerCount = document.querySelector('.wishlist-count');
      if (headerCount) headerCount.textContent = list.length;
      return list;
    }
  };

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.wishlist-btn');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      const handle = btn.getAttribute('data-wishlist');
      if (handle) window.SL_Wishlist.toggle(handle);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    const list = getList();
    document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
      const handle = btn.getAttribute('data-wishlist');
      if (handle && list.indexOf(handle) !== -1) {
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');
        btn.textContent = '♥';
      }
    });
    // ★修复：不覆盖收藏页的 "N items added" 计数（收藏页有自己的格式）
    const counter = document.getElementById('wishlist-count');
    if (counter && !counter.classList.contains('wishlist-page-count')) {
      counter.textContent = list.length;
    }
    // ★新增：header 收藏角标同步
    const headerCount = document.querySelector('.wishlist-count');
    if (headerCount) headerCount.textContent = list.length;
  });
})();